import { render, staticRenderFns } from "./scatter_component.vue?vue&type=template&id=0f50c8c9"
import script from "./scatter_component.vue?vue&type=script&lang=js"
export * from "./scatter_component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports